/* NSE display-only currency converter.
   The store sells in INR only (Razorpay checkout; Shopify Payments — needed for Shopify's own multi-currency — isn't
   available in India). For visitors from other countries this rewrites ₹ prices inside price elements to an approximate
   local amount ("≈ €382") using daily rates, and adds a note that checkout is charged in INR. Checkout, cart totals and
   structured data are untouched. Search-engine bots and India always see ₹, so Google's price checks match the JSON-LD.
   Config comes from layout/theme.liquid: window.NSE_FX = { showInr, note, cartNote }. */
(function () {
  var cfg = window.NSE_FX || {};
  var country = (window.Shopify && Shopify.country) || 'IN';
  if (/bot|crawl|spider|slurp|google-inspectiontool|lighthouse|pagespeed|headlesschrome-seo/i.test(navigator.userAgent)) return;

  var CUR = {
    AT:'EUR', BE:'EUR', BG:'EUR', CY:'EUR', DE:'EUR', EE:'EUR', ES:'EUR', FI:'EUR', FR:'EUR', GR:'EUR', HR:'EUR', IE:'EUR',
    IT:'EUR', LT:'EUR', LU:'EUR', LV:'EUR', MT:'EUR', NL:'EUR', PT:'EUR', SI:'EUR', SK:'EUR', MC:'EUR', SM:'EUR', VA:'EUR', AD:'EUR', ME:'EUR', XK:'EUR',
    GB:'GBP', US:'USD', CA:'CAD', AU:'AUD', NZ:'NZD', CZ:'CZK', DK:'DKK', HU:'HUF', PL:'PLN', RO:'RON', SE:'SEK', NO:'NOK', CH:'CHF', IS:'ISK',
    AE:'AED', SA:'SAR', QA:'QAR', KW:'KWD', BH:'BHD', OM:'OMR', SG:'SGD', MY:'MYR', HK:'HKD', JP:'JPY', CN:'CNY', KR:'KRW', TH:'THB',
    ID:'IDR', PH:'PHP', VN:'VND', LK:'LKR', NP:'NPR', BD:'BDT', PK:'PKR', ZA:'ZAR', NG:'NGN', KE:'KES', EG:'EGP', IL:'ILS', TR:'TRY',
    MX:'MXN', BR:'BRL', AR:'ARS', CL:'CLP', CO:'COP', MU:'MUR', MV:'MVR', FJ:'FJD'
  };
  var code = CUR[country];
  if (!code || code === 'INR') return;

  var KEY = 'nse-fx-v1', TTL = 12 * 3600 * 1000;
  function cached() {
    try { var c = JSON.parse(localStorage.getItem(KEY) || 'null'); if (c && c.rates && Date.now() - c.t < TTL) return c.rates; } catch (e) {}
    return null;
  }
  function getRates() {
    var c = cached(); if (c) return Promise.resolve(c);
    return fetch('https://open.er-api.com/v6/latest/INR').then(function (r) { return r.json(); }).then(function (d) {
      if (!d || d.result !== 'success' || !d.rates) throw new Error('fx');
      try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), rates: d.rates })); } catch (e) {}
      return d.rates;
    });
  }

  getRates().then(function (rates) {
    var rate = rates[code]; if (!rate) return;
    var fmt0, fmt2;
    try {
      fmt0 = new Intl.NumberFormat('en', { style: 'currency', currency: code, maximumFractionDigits: 0, minimumFractionDigits: 0 });
      fmt2 = new Intl.NumberFormat('en', { style: 'currency', currency: code, maximumFractionDigits: 2, minimumFractionDigits: 2 });
    } catch (e) { return; }
    var money = function (inr) { var v = inr * rate; return (v >= 100 ? fmt0 : fmt2).format(v); };
    var RX = /(\+?)₹\s?([\d,]+(?:\.\d{1,2})?)/g;
    /* price containers only — menus ("Buy under ₹5,000"), announcements and headings keep their rupee wording */
    var SCOPE = '[class*="price"], #nse-price, .nse-now, .totals__total-value, #nlp-val, .nlp-tot .val, .nlp .pr, .nse-ao__price, .nse-dcard__now, .nse-dcard__was';
    var SKIP = 'nav, .header__inline-menu, .menu-drawer, .mega-menu, .header__submenu, script, style, noscript, textarea, input, select, .nse-fx-note';
    var WAS = 's, del, strike, .price-was, .line-through, .cart-item__old-price, .nse-dcard__was, .price-item--regular';
    var busy = false;

    function convertNode(node) {
      var t = node.nodeValue;
      if (!t || t.indexOf('₹') < 0 || node.__fxOut === t) return;
      var el = node.parentElement; if (!el || el.closest(SKIP)) return;
      var was = !!el.closest(WAS);
      var out = t.replace(RX, function (m, plus, num) {
        var inr = parseFloat(num.replace(/,/g, '')); if (!isFinite(inr)) return m;
        return plus + (plus || was ? '' : '≈ ') + money(inr);
      });
      if (out === t) return;
      var holder = el.closest(SCOPE);
      if (holder) holder.setAttribute('data-inr', t.trim());
      node.nodeValue = out; node.__fxOut = out;
      if (cfg.showInr && holder && holder.matches('#nse-price .nse-now, .nse-now') && !holder.querySelector('.nse-fx-inr')) {
        var s = document.createElement('span'); s.className = 'nse-fx-inr'; s.textContent = t.trim(); holder.appendChild(s);
      }
    }
    function scan(root) {
      var scopes = (root.nodeType === 1 && root.matches && root.matches(SCOPE)) ? [root] : [];
      if (root.querySelectorAll) scopes = scopes.concat([].slice.call(root.querySelectorAll(SCOPE)));
      scopes.forEach(function (sc) {
        var w = document.createTreeWalker(sc, NodeFilter.SHOW_TEXT, null), n;
        while ((n = w.nextNode())) convertNode(n);
      });
    }
    function notes() {
      /* product page: one line under the price; cart drawer + cart page: under the total, with the exact INR amount charged */
      var p = document.getElementById('nse-price');
      if (p && !p.parentNode.querySelector('.nse-fx-note--page')) {
        var n = document.createElement('p'); n.className = 'nse-fx-note nse-fx-note--page'; n.textContent = cfg.note || 'Approximate price. You’ll be charged in INR at checkout.';
        p.insertAdjacentElement('afterend', n);
      }
      [].slice.call(document.querySelectorAll('.totals')).forEach(function (tot) {
        var v = tot.querySelector('.totals__total-value'); if (!v) return;
        var inr = v.getAttribute('data-inr'); if (!inr) return;
        var n = tot.parentNode.querySelector('.nse-fx-note--cart');
        if (!n) { n = document.createElement('p'); n.className = 'nse-fx-note nse-fx-note--cart'; tot.insertAdjacentElement('afterend', n); }
        var txt = (cfg.cartNote || 'You’ll be charged [amount] (INR) at checkout. Your bank converts it.').replace('[amount]', inr);
        if (n.textContent !== txt) n.textContent = txt;
      });
    }
    function run(root) { if (busy) return; busy = true; try { scan(root || document.body); notes(); } finally { busy = false; } }

    /* country picker: "Belgium | INR ₹" -> "Belgium | EUR €" */
    var sym = (fmt0.formatToParts(1).filter(function (x) { return x.type === 'currency'; })[0] || {}).value || code;
    [].slice.call(document.querySelectorAll('.localization-form__select span, .disclosure__button span, .localization-selector span')).forEach(function (s) {
      if (/INR/.test(s.textContent)) s.textContent = s.textContent.replace(/INR\s*₹?/, code + ' ' + sym);
    });

    run();
    var tm; new MutationObserver(function (muts) {
      if (busy) return;
      clearTimeout(tm); tm = setTimeout(function () { run(document.body); }, 60);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }).catch(function () { /* rates unavailable → prices simply stay in ₹ */ });
})();
